import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { PublicApplicationAPI } from '@lib/api/endpoints/Applications';
import { RootState } from '@lib/redux.lib/store';

export const useGetJobsBoardLocations = (
  searchTerm: string | null | undefined
) => {
  const trimmedSearchTerm = searchTerm?.trim() || '';

  const loggedInUserId = useSelector(
    (state: RootState) => state.app?.user?.profile?.id
  );

  const { data, isLoading, isError } = useQuery({
    queryKey: ['jobsBoardLocations', trimmedSearchTerm, loggedInUserId],
    queryFn: () =>
      PublicApplicationAPI.getJobsBoardLocations(
        trimmedSearchTerm,
        loggedInUserId
      ),
    refetchOnWindowFocus: false,
    enabled: !!loggedInUserId,
  });

  return {
    data,
    isLoading,
    isError,
  };
};
